export class Status {
  errorMsg: string = '';
  loading: boolean = false;

  //#region Auth
  authErrorMsg: string = '';
  authLoading: boolean = false;

  getArchivUsersLoading: boolean = false;
  getBenutzerLoading: boolean = false;
  createBenutzerLoading: boolean = false;
  updateBenutzerLoading: boolean = false;
  deleteBenutzerLoading: boolean = false;
  benutzerErrorMsg: string = '';
  //#endregion

  //#region Personaldaten
  getPersonaldatenLoading: boolean = false;
  personaldatenErrorMsg: string = '';
  //#endregion

  //#region Mandanten
  getMandantenLoading: boolean = false;
  mandantenErrorMsg: string = '';
  //#endregion

  //#region Druckvorlagen
  getDruckvorlageLoading: boolean = false;
  createDruckvorlageLoading: boolean = false;
  updateDruckvorlageLoading: boolean = false;
  deleteDruckvorlageLoading: boolean = false;
  druckvorlageErrorMsg: string = '';
  //#endregion

  //#region Einstellungen
  getEinstellungenLoading: boolean = false;
  updateEinstellungenLoading: boolean = false;
  einstellungenErrorMsg: string = '';
  //#endregion

  //#region Signatur
  getSignaturenLoading: boolean = false;
  createSignaturLoading: boolean = false;
  updateSignaturLoading: boolean = false;
  deleteSignaturLoading: boolean = false;
  signaturErrorMsg: string = '';
  //#endregion

  //#region Variablen
  getVariablenLoading: boolean = false;
  createVariablenLoading: boolean = false;
  updateVariablenLoading: boolean = false;
  deleteVariablenLoading: boolean = false;
  variablenErrorMsg: string = '';
  //#endregion

  //#region Vorlagen
  getVorlageLoading: boolean = false;
  createVorlageLoading: boolean = false;
  updateVorlageLoading: boolean = false;
  deleteVorlageLoading: boolean = false;
  vorlageErrorMsg: string = '';
  //#endregion

  //#region Textbausteine
  getTextbausteineLoading: boolean = false;
  createTextbausteinLoading: boolean = false;
  updateTextbausteinLoading: boolean = false;
  deleteTextbausteinLoading: boolean = false;
  textbausteinErrorMsg: string = '';
  //#endregion

  //#region Vertrag
  getVertraegeLoading: boolean = false;
  createVertragLoading: boolean = false;
  updateVertragLoading: boolean = false;
  deleteVertragLoading: boolean = false;
  vertragErrorMsg: string = '';

  getVertragAnalysenLoading: boolean = false;
  vertragAnalysenErrorMsg: string = '';
  //#endregion

  //#region Vertrag Dokumente
  getVertragDokumenteLoading: boolean = false;
  createVertragDokumentLoading: boolean = false;
  updateVertragDokumentLoading: boolean = false;
  deleteVertragDokumentLoading: boolean = false;
  vertragDokumentErrorMsg: string = '';
  //#endregion

  //#region Vertragspartner
  getVertragspartnerLoading: boolean = false;
  createVertragspartnerLoading: boolean = false;
  updateVertragspartnerLoading: boolean = false;
  deleteVertragspartnerLoading: boolean = false;
  vertragspartnerErrorMsg: string = '';
  //#endregion

  //#region Vertrag Abschnitt
  getAbschnitteLoading: boolean = false;
  createAbschnittLoading: boolean = false;
  updateAbschnittLoading: boolean = false;
  deleteAbschnittLoading: boolean = false;
  abschnittErrorMsg: string = '';
  //#endregion

  sidebarCollapsed: boolean = false;
}

export interface KeyValuePair {
  key: number | string;
  value: number | string;
}

export interface ErrorResponseData {
  detail: string;
  status: number;
  title: string;
  type: string;
}

export enum SortDirection {
  asc,
  desc,
}

export class PagedRequest {
  page: number = 1;
  pageSize: number = 25;
  sortBy: string = '';
  sortDirection: SortDirection = SortDirection.asc;
  filter: string = '';
}

export interface PagedResult<T> {
  items: Array<T>;
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

//#region Einstellungen
export interface Einstellungen {
  id: number;
  einstellung1: string;
  wert: string;
  daten: string;
}

export class UpsertEinstellungQRCodeTrennzeichen {
  qrCodeTrennzeichen: string = '';
}
//#endregion
